export const MenuState = {
  main: 'main',
  language: 'language',
  theme: 'theme',
} as const

export type MenuStateType = (typeof MenuState)[keyof typeof MenuState]
